module.exports = __webpack_public_path__ + "img/info_square.6a87f53d.svg";